/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react.old';

import Theme from 'galax/react/map/util/theme';


const getUser = ({ location }) =>
{
  return location.getUser();
}


const getOpacity = ({ isOutOfRange }) =>
{
  return isOutOfRange ? 0.0 : 1;
}


const getTransform = ({ geometry, location, ...props }) =>
{
  const hex = geometry.getZone(location);

  const { x, y } = hex.getAbsolute(hex.getCenter());

  return `translate(${x}px, ${y}px)`;
}


const Center = styled(Theme)`
  opacity: ${props => getOpacity(props)};
  transform: ${props => getTransform(props)};
`;


export default ({ children, ...props }) =>
(
  <Center {...props} user = {getUser(props)} >
    {children}
  </Center>
);
